import { filter, map } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { ScheduleAction } from '@cbridge-packages/schedule';
import { RouterAction } from '@cbridge-packages/routing';
import { generateScheduleProfileRoute } from '@cbridge-packages/routing-client-admin';

export const handleScheduleNotFoundEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(ScheduleAction.load.failed),
  filter(({ error }) => error.status === 404),
  map(() => RouterAction.replace([generateScheduleProfileRoute()])),
);
